import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { CancelaConsultaAtendimentoRequest, Types } from './types';

// ACTIONS
import {
	cancelaConsultaAtendimentoSuccess,
	cancelaConsultaAtendimentoFailure,
} from './actions';

function* cancelaConsultaAtendimentoRequest(request: ReducerAction) {
	const { payload }: { payload: CancelaConsultaAtendimentoRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`atendimentos/${CHANNEL}/cancelamentos`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cancelaConsultaAtendimentoSuccess(response));
	} else {
		yield put(cancelaConsultaAtendimentoFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CANCELA_CONSULTA_ATENDIMENTO_REQUEST,
		cancelaConsultaAtendimentoRequest,
	),
]);
